import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONFIG } from '../../constants/constants';


@Component({
  selector: 'footer-app',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})//Controlador para el footer general de la aplicacion
export class FooterComponent {
  public defaultLanguage: string;
  versionApp: string;

  constructor(private _translateService: TranslateService) {
    this.getNavigatorLang();
    this._translateService.addLangs(["es", "en"]);
    this._translateService.use(this.defaultLanguage);
    this.versionApp = CONFIG.VERSIONAPP;
  }

  private getNavigatorLang() {
    this.defaultLanguage = this._translateService.getBrowserLang();
    if (this.defaultLanguage != 'es' && this.defaultLanguage != 'en') {
      this.defaultLanguage = 'es';
    }
  }

}


